import { render, staticRenderFns } from "./PaywallView.vue?vue&type=template&id=2d4ccde2&"
import script from "./PaywallView.vue?vue&type=script&lang=js&"
export * from "./PaywallView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports